import type { RawDraftEntity } from 'draft-js';

// FIX to the built-in image entity transform
// see https://github.com/jpuri/draftjs-to-html/blob/c02452e3ce6719f84f38d39f8f9b0a9e32bf871f/js/block.js#L334-L340
export const customEntityTransform = (entity: RawDraftEntity): string | undefined => {
  if (entity.type === 'IMAGE') {
    const imageMarkup = `<img src="${entity.data.src}" alt="${entity.data.alt}" style="height: ${entity.data.height};width: ${entity.data.width}"/>`;

    const { alignment } = entity.data;

    if (alignment && alignment.length) {
      return `<div style="text-align:${alignment === 'none' ? 'center' : alignment};">${imageMarkup}</div>`;
    }

    return imageMarkup;
  }

  return;
};
